/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Sound_DefaultInputs */

const en_us2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const pt_br2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão`)
};

const es_419_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predeterminado`)
};

const pt_pt2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinido`)
};

const fr_fr2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut`)
};

const de_de2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const it_it2_workout_logging_sound_default = /** @type {(inputs: Workout_Logging_Sound_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Workout_Logging_Sound_DefaultInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_sound_default = /** @type {((inputs?: Workout_Logging_Sound_DefaultInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Sound_DefaultInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_sound_default(inputs)
	if (locale === "es-419") return es_419_workout_logging_sound_default(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_sound_default(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_sound_default(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_sound_default(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_sound_default(inputs)
	return en_us2_workout_logging_sound_default(inputs)
});
export { workout_logging_sound_default as "workout-logging.sound_default" }